import { toast } from 'react-toastify';
import * as Sentry from '@sentry/browser';
import { parseApiError } from './parseApiError';

export function notifyApiError(error, entity) {
  const parsed = parseApiError(error, entity);
  if (!parsed.hasError) {
    return parsed;
  }
  if (parsed.status >= 500 || parsed.source === 'network') {
    Sentry.captureException(error);
  }
  toast.error(parsed.toastMessage, { theme: 'colored', toastId: parsed.toastMessage });
  return parsed;
}
